import { viperApi, clinicalApiPath } from '@/services/viper-api'

export const documentTypeService = {
  basePath: `${clinicalApiPath}/document-types`,

  list() {
    return viperApi.get(this.basePath)
  },

  getUploadable() {
    return viperApi.get(`${this.basePath}/uploadable`)
  }
}
